import { ComponentAPI } from '@philips-emr/tws-core';

class SuperscriptionAPI extends ComponentAPI {
  getData(): {}[] {
    return this.state.data;
  }

  setData(data: {}[]): void {
    if (Array.isArray(data)) {
      this.setState({ data });
    }
  }

  isShowLabel(): boolean {
    return this.state.showLabel;
  }

  setShowLabel(showLabel: boolean): void {
    this.setState({ showLabel });
  }

  isShowTitle(): boolean {
    return this.state.showTitle;
  }

  setShowTitle(showTitle: boolean): void {
    this.setState({ showTitle });
  }

  getTitleExpression(): string {
    return this.state.titleExpression;
  }

  setTitleExpression(titleExpression: string): void {
    this.setState({ titleExpression });
  }
}

export default SuperscriptionAPI;
